import { z } from 'zod';
/**
 * Delete External Contact Request Schema
 * DELETE /api/v2/external-contacts/:id
 */ export const DeleteExternalContactRequestSchema = z.object({});
/**
 * Delete External Contact Response Schema
 * DELETE /api/v2/external-contacts/:id
 */ export const DeleteExternalContactResponseSchema = z.object({
    success: z.boolean()
});

//# sourceMappingURL=delete-external-contact.schema.js.map